/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Resend_DescriptionInputs */

const en_admin_settings_groups_resend_description = /** @type {(inputs: Admin_Settings_Groups_Resend_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend email service`)
};

/**
* | output |
* | --- |
* | "Resend email service" |
*
* @param {Admin_Settings_Groups_Resend_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_resend_description = /** @type {((inputs?: Admin_Settings_Groups_Resend_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Resend_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_resend_description(inputs)
});
export { admin_settings_groups_resend_description as "admin.settings.groups.resend.description" }